import BaseRepository from "@/services/resources/repository";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema);
    }

    bySlug(slug) {
        const name = slug.replaceAll('-', ' ');

        return this.transformer.one(
            this.try(
                this.baseQuery()
                    .where('name', name)
                    .first()
            )
        );
    }
}

export default Repository;
